import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDisconnect',
  standalone: true
})
export class IsDisconnectPipe implements PipeTransform {

  transform(value: string | Date): unknown {
    const now = new Date();
    const current = new Date(value?.toString() || 0);

    return now.getTime() - current.getTime() > (1000 * 60 * 10);
  }

}
